const printFallback = (entity, fallback) => {
  if (typeof fallback === 'undefined') {
    return entity.displayName;
  } else if (!fallback) {
    return '';
  }
  return fallback;
};

export default (entity, ref, fallback) =>
  (entity.copy && entity.copy[ref]) || printFallback(entity, fallback);
